export default __webpack_public_path__ + "static/media/crflogo.129e3c23.png";